<template>
  <div class="antd-pro-components-article-list-content-index-listContent">
    <div class="extra">
      <a-avatar v-if="avatar" :src="avatar" size="small" />
      所属公司：<a>{{ owner }}</a>
      <em>发布于：{{ moment(createAt).fromNow() }}</em>
      <em>上次修改：{{ moment(updateAt).fromNow() }}</em>
    </div>
    <div class="description">
      <p v-if="isShow">{{ description }}</p>
      <p><a href="javascript:;" @click="() => isShow = !isShow">{{ isShow? '隐藏' :'展示' }} <a-icon :type="isShow ? 'up' : 'down'"/></a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JobListContent',
  props: {
    prefixCls: {
      type: String,
      default: 'antd-pro-components-article-list-content-index-listContent'
    },
    description: {
      type: String,
      default: ''
    },
    owner: {
      type: String,
      default: ''
    },
    avatar: {
      type: String,
      default: ''
    },
    createAt: {
      type: String,
      default: ''
    },
    updateAt: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isShow: false
    }
  }
}
</script>

<style lang="less" scoped>
@import '../index.less';

.antd-pro-components-article-list-content-index-listContent {
  .description {
    max-width: 720px;
    line-height: 22px;
  }
  .extra {
    margin-top: 16px;
    color: @text-color-secondary;
    line-height: 22px;

    & /deep/ .ant-avatar {
      position: relative;
      top: 1px;
      width: 20px;
      height: 20px;
      margin-right: 8px;
      vertical-align: top;
    }

    & > em {
      margin-left: 16px;
      color: @disabled-color;
      font-style: normal;
    }
  }
}

@media screen and (max-width: @screen-xs) {
  .antd-pro-components-article-list-content-index-listContent {
    .extra {
      & > em {
        display: block;
        margin-top: 8px;
        margin-left: 0;
      }
    }
  }
}
</style>
